import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { count, FlowCell, NOT_APPLICABLE } from '../../utils/dashboard-flow';

// Uma célula das tabelas por canal da home: número (link para a lista no passo), "de N canais" na
// linha de total, notas curtas ("3 com falha", "2 aguardando") e "Não se aplica" com o motivo.
@Component({
  selector: 'app-dashboard-flow-cell',
  standalone: true,
  imports: [RouterModule, NgbTooltipModule],
  styles: [
    `
      :host {
        display: block;
      }

      .flow-num {
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        color: var(--bs-heading-color, #384551);
      }

      a.flow-num,
      a.flow-note {
        text-decoration: none;
      }

      a.flow-num:hover,
      a.flow-note:hover {
        text-decoration: underline;
      }

      .flow-num.text-danger {
        color: var(--bs-danger) !important;
      }

      .flow-note,
      .flow-reason {
        display: block;
        font-size: 0.75rem;
        line-height: 1.35;
        white-space: nowrap;
      }

      .flow-note--muted,
      .flow-reason {
        color: var(--bs-secondary-color, #a1acb8);
      }

      .flow-note--danger {
        color: var(--bs-danger);
      }

      .flow-note--warning {
        color: var(--bs-warning);
      }

      .flow-na {
        color: var(--bs-secondary-color, #a1acb8);
        white-space: nowrap;
      }

      /* Motivo pode ser maior que a coluna: quebra em vez de alargar a tabela. */
      .flow-reason {
        white-space: normal;
        min-width: 8rem;
        max-width: 11rem;
      }
    `,
  ],
  template: `
    @if (cell.value === null) {
      <span class="flow-na">{{ notApplicable }}</span>
      @if (cell.reason) {
        <span class="flow-reason">{{ cell.reason }}</span>
      }
    } @else {
      @if (cell.link) {
        <a class="flow-num" [class.text-danger]="cell.tone === 'danger'" [routerLink]="cell.link.path"
          [queryParams]="cell.link.query" [ngbTooltip]="cell.tip || null" container="body">{{ display }}</a>
      } @else {
        <span class="flow-num" [class.text-danger]="cell.tone === 'danger'" [ngbTooltip]="cell.tip || null"
          container="body">{{ display }}</span>
      }
      @if (cell.of) {
        <span class="flow-note flow-note--muted">{{ cell.of }}</span>
      }
      @for (n of cell.notes; track $index) {
        @if (n.link) {
          <a class="flow-note flow-note--{{ n.tone }}" [routerLink]="n.link.path" [queryParams]="n.link.query">{{ n.text }}</a>
        } @else {
          <span class="flow-note flow-note--{{ n.tone }}">{{ n.text }}</span>
        }
      }
    }
  `,
})
export class DashboardFlowCellComponent {
  @Input({ required: true }) cell!: FlowCell;

  readonly notApplicable = NOT_APPLICABLE;

  get display(): string {
    return this.cell.text ?? count(this.cell.value ?? 0);
  }
}
